export default "__VITE_ASSET__B00iIEqy__"